import { ACTIONS_BERU } from '../actions/beru';

export const beru = (state = {}, action) => {
  switch (action.type) {
    case ACTIONS_BERU.INIT_ORDERS: {
      return { ...state, orders: [...action.data] };
    }
    case ACTIONS_BERU.DELETE_ORDERS: {
      return { ...state, orders: [] };
    }

    default:
      return state;
  }
};
